var CLEAR_SELECTION = 'WITH_TABLE_SUMMARY__CLEAR_SELECTION';
var ACTION_TYPES = {
  CLEAR_SELECTION: CLEAR_SELECTION
};
export default ACTION_TYPES;